import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');

        try {
            const response = await api.post('/auth/forgot-password', { email });
            setMessage(response.data.message || 'Email de resetare trimis cu succes.');
        } catch (err) {
            setError(err.response?.data?.error || 'Eroare la trimiterea email-ului.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-slate-900 flex items-center justify-center p-4">
            <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 w-full max-w-md p-8">
                <div className="text-center mb-6">
                    <h2 className="text-2xl font-bold text-brand-blue dark:text-blue-300">Resetare Parolă</h2>
                    <p className="text-gray-500 dark:text-gray-400">Introdu email-ul asociat contului tău</p>
                </div>

                {message ? (
                    <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 text-green-700 dark:text-green-300 px-4 py-3 rounded-lg mb-4 text-center">
                        {message}
                        <div className="mt-4">
                            <Link to="/login" className="text-brand-blue dark:text-blue-300 font-semibold hover:underline hover:text-brand-blue-hover">
                                Înapoi la Login
                            </Link>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Email</label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-2 border border-gray-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-brand-blue focus:border-transparent bg-white dark:bg-slate-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                                placeholder="email@exemplu.ro"
                            />
                        </div>

                        {error && (
                            <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-300 px-4 py-3 rounded-lg">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-brand-blue text-white py-3 rounded-lg font-semibold hover:bg-brand-blue-hover transition disabled:opacity-50 shadow-sm"
                        >
                            {loading ? 'Se trimite...' : 'Trimite Link Resetare'}
                        </button>

                        <div className="text-center">
                            <Link to="/login" className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-blue dark:hover:text-blue-300 hover:underline">
                                Anulează și revino la Login
                            </Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
